'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofCell = require('../dof-cell');

var _dofCell2 = _interopRequireDefault(_dofCell);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icon = require('../setting/icon.base64.js');
var CHECKED = icon['public_ic_done@2x'];
var CHECKEDDIABLO = icon['public_ic_done_diablo@2x'];


var animation = weex.requireModule('animation');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofCell: _dofCell2.default, DofIconfont: _dofIconfont2.default },
  props: {
    hasSubBottomBorder: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      require: true
    },
    value: {
      type: [String, Number, Object],
      require: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    // 是否宽度750（边框样式不一样）
    isFullBorder: {
      type: Boolean,
      default: true
    },
    isLast: {
      type: Boolean,
      default: false
    },
    // 是否显示边框
    isShowBorder: {
      type: Boolean,
      default: false

      // itemImg: {
      //   type: String,
      //   default: ''
      // },
    } },
  data: function data() {
    return {};
  },
  computed: {
    radioIcon: function radioIcon() {
      var icon = this.icon,
          disabled = this.disabled,
          checked = this.checked;

      return checked ? this._isDiablo ? CHECKEDDIABLO : CHECKED : '';
    },
    backgroundColor: function backgroundColor() {
      var _isColmo = this._isColmo,
          _isDiablo = this._isDiablo;
      // 27282a

      return _isColmo ? '#303237' : _isDiablo ? '#101315' : '#FFFFFF';
    },
    cellStyle: function cellStyle() {
      return { backgroundColor: this.backgroundColor };
    }
  },
  methods: {
    dofCellClick: function dofCellClick() {
      var disabled = this.disabled,
          value = this.value;

      if (!disabled) {
        this.$emit('dofRadioItemChecked', { value: value, disabled: disabled });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-radio-list/radio-item.vue
// module id = 374
// module chunks = 0 1